import { lazy } from 'react'

export const SavedAddressesLazy = lazy(() => import('./SavedAddresses'))
